"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  defaultOnlyOneHandlerTypes: true,
  defaultDefaultHandlers: true,
  createConfiguredComposeHandlers: true,
  handlers: true
};
exports.handlers = exports["default"] = exports.createConfiguredComposeHandlers = exports.defaultDefaultHandlers = exports.defaultOnlyOneHandlerTypes = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _globalMessage = require("../../GlobalMessage/store/globalMessage.actions");

var _GlobalMessage = require("../../GlobalMessage/types/GlobalMessage.types");

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _messages = require("./messages");

Object.keys(_messages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _messages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _messages[key];
    }
  });
});

var handlers = _interopRequireWildcard(require("./handlers"));

exports.handlers = handlers;

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});
var defaultOnlyOneHandlerTypes = [_types.HandlerTypes.Validation, _types.HandlerTypes.Unauthorized, _types.HandlerTypes.Conflict, _types.HandlerTypes.NotFound, _types.HandlerTypes.Forbidden, _types.HandlerTypes.InternalServerError, _types.HandlerTypes.ResponseMessage];
exports.defaultOnlyOneHandlerTypes = defaultOnlyOneHandlerTypes;
var defaultDefaultHandlers = [handlers.handleJsError((0, _globalMessage.showGlobalMessage)({
  text: _messages.MESSAGES.CLIENT_SIDE_ERR,
  type: _GlobalMessage.MessageType.Error
})), handlers.handleForbidden((0, _globalMessage.showGlobalMessage)({
  type: _GlobalMessage.MessageType.Error,
  text: _messages.MESSAGES.PERMISSION_DENIED_ERR
})), handlers.handleInternalError((0, _globalMessage.showGlobalMessage)({
  text: _messages.MESSAGES.INTERNAL_SERVER_ERR,
  type: _GlobalMessage.MessageType.Error
})), handlers.handleResponseMessage(function (text) {
  return (0, _globalMessage.showGlobalMessage)({
    text: text,
    type: _GlobalMessage.MessageType.Error
  });
}), handlers.handleHttpError(function (error) {
  return (0, _globalMessage.handleServerError)(error);
})];
exports.defaultDefaultHandlers = defaultDefaultHandlers;

var createConfiguredComposeHandlers = function createConfiguredComposeHandlers() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onlyOneHandlerTy = _ref.onlyOneHandlerTypes,
      onlyOneHandlerTypes = _ref$onlyOneHandlerTy === void 0 ? defaultOnlyOneHandlerTypes : _ref$onlyOneHandlerTy,
      _ref$defaultHandlers = _ref.defaultHandlers,
      defaultHandlers = _ref$defaultHandlers === void 0 ? defaultDefaultHandlers : _ref$defaultHandlers;

  return function () {
    for (var _len = arguments.length, errorHandlersFn = new Array(_len), _key = 0; _key < _len; _key++) {
      errorHandlersFn[_key] = arguments[_key];
    }

    return _utils.composeHandlers.apply(void 0, (0, _toConsumableArray2["default"])(errorHandlersFn.reduce(function (res, handler) {
      var isOnlyOneHandler = onlyOneHandlerTypes.includes(handler.type);
      var prevIndex = res.findIndex(function (h) {
        return h.type === handler.type;
      });

      if (isOnlyOneHandler && (prevIndex || prevIndex === 0) && prevIndex !== -1) {
        res.splice(prevIndex, 1);
      }

      return [].concat((0, _toConsumableArray2["default"])(res), [handler]);
    }, defaultHandlers)));
  };
};

exports.createConfiguredComposeHandlers = createConfiguredComposeHandlers;

/**
 * Redux-Observable epics catchError handlers.
 *
 * @param {...Array<IErrorHandlerFn>} actionHandlers
 * @returns {(response: TAnyResponseError) => Observable<AnyAction>}
 *
 * @example
 *
 * catchError(handleError(
 *   handlers.handlerAnyError(
 *     // It support actions or action-creators
 *     ({ type: 'ANY_ACTION' }),
 *     (errors: TErrors, response: TAnyResponseError) => ({ type: 'REQUEST_FAILED', payload: errors, meta: response, error: true }),
 *     // Function that returns void supported also too
 *     (errors: TErrors) => { console.log(TErrors) },
 *   ),
 *   // Also you might re-define default behavior as you wish
 *   // to see default behavior look at constant `defaultUniqHandlers` value
 *   handlers.handleResponseMessage(text => showGlobalMessage({ text, variant: 'dialog' })),
 * ))
 */
var _default = createConfiguredComposeHandlers();

exports["default"] = _default;